export default __webpack_public_path__ + "static/Natural_Light_Indoor_1280kbps-8b4e1e15f0ab5a52c4aab29efd5f4d55.avif";